module.exports = __webpack_public_path__ + "img/tutorial01.c614118a.svg";